import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LearningContentInnerWrapper from './LearningContentInnerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LearningContentPageLayout = ({
  header,
  navigation,
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(LearningContentInnerWrapper, {
    backgroundColor: "fill-surface-recessed",
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: navigation || isTablet ? undefined : '1000',
      children: [header, navigation ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: isTablet ? 'column-reverse' : 'row',
        gap: "600",
        children: [navigation, /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          minInlineSize: "0",
          children: children
        })]
      }) : children]
    })
  });
};
export default LearningContentPageLayout;